
<div class="table-container report-space">
    <table aria-describedby="table" class="table table-hover table-bordered table_width table-response" id="tabledemo">
    <thead>
        <tr class="tr-th">
          <th scope="col">Report Name</th>
          <th scope="col">Report Description</th>
          
        </tr>
      </thead>
      <tbody>
        <tr class="tr-td" *ngFor="let data of data1">
          <td>{{data.reportName}}</td>
          <td> <a [href]="data.reportUrl | safeUrl" target = "_blank">{{data.reportDescription}}</a></td>

        </tr>
      </tbody>
    </table>
  
</div>

